import React, { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import gql from "graphql-tag";

const TABLE_BY_ID = gql`
  query TableByID($id: String) {
    tableById(id: $id) {
      _id
      name
      rows {
        team {
          name
        }
        points
        played
      }
    }
  }
`;

export default function Table({ game }) {
  const [getTable, { data }] = useLazyQuery(TABLE_BY_ID);

  useEffect(() => {
    if (game) {
      getTable({ variables: { id: game?.season?._id } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [game]);

  return (
    <table>
      {data?.tableById?.rows?.map((row, index) => {
        return (
          <tr>
            <td>{index}</td>
            <td>{row?.team?.name}</td>
            <td>{row?.played}</td>
            <td>{row?.points}</td>
          </tr>
        );
      })}
    </table>
  );
}
